import TimelyCareLogo from 'assets/images/timely_care.svg'
import TimelyCareLogoWhite from 'assets/images/timely_care_white.svg'
import TimelyCareLogoWhiteText from 'assets/images/timely_care_white_text.svg'

export const enum LogoVariants {
  normal = 'normal',
  white = 'white',
  whiteText = 'whiteText',
}

const LogoVariantSvgs = {
  [LogoVariants.normal]: TimelyCareLogo,
  [LogoVariants.white]: TimelyCareLogoWhite,
  [LogoVariants.whiteText]: TimelyCareLogoWhiteText,
} as const

type ApplicationLogoProps = {
  className?: string
  variant?: LogoVariants
}

const ApplicationLogo = ({ className, variant = LogoVariants.normal }: ApplicationLogoProps) => (
  <img alt="TimelyCare Logo" src={LogoVariantSvgs[variant]} className={className} />
)

export default ApplicationLogo
